import React from "react";
import i18nLabels from "./Address.i18n";
import { useHistory } from "react-router-dom";
import DecorateContainer from "components/DecorateContainer";
import AddressContainer from "./AddressContainer";
import { useDispatch, useSelector } from "react-redux";
import { addressSelector, productSelector } from "app/selectors";

export default function Address(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const address = useSelector(addressSelector);
  const product = useSelector(productSelector);
  const { addressList = {} } = address;
  const { productInfo = {} } = product;
  const addressProps = {
    ...props,
    i18nLabels,
    history,
    dispatch,
    addressList,
    productInfo,
  };
  return (
    <DecorateContainer {...addressProps} childComponent={AddressContainer} />
  );
}
